import { render } from "./SectionBanner.vue?vue&type=template&id=1fee192e"
import script from "./SectionBanner.vue?vue&type=script&lang=js"
export * from "./SectionBanner.vue?vue&type=script&lang=js"

import "./SectionBanner.vue?vue&type=style&index=0&id=1fee192e&lang=scss"

import exportComponent from "/Users/bahramhasanov/_PHP/bouquet-new-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__